module.exports = __webpack_public_path__ + "static/tower-view-image-102a1025386ebb136e5101f8fb4387a0.png";